import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3402';

export const paymentsService = {
  async createStripeSubscription(tierId: string): Promise<{ subscriptionId: string; membershipId: string; clientSecret: string | null }> {
    const token = localStorage.getItem('accessToken');
    const res = await axios.post(`${API_BASE_URL}/api/payments/subscriptions/stripe`, { tierId }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  async getInvoice(paymentId: string): Promise<Blob> {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/payments/${paymentId}/invoice`, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'blob',
    });
    return res.data;
  },

  async downloadInvoice(paymentId: string): Promise<void> {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/payments/${paymentId}/invoice/pdf`, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `invoice-${paymentId}.html`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  async get(paymentId: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/payments/${paymentId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { payment: any };
  },

  async history(params: { status?: 'PENDING' | 'COMPLETED' | 'FAILED' | 'REFUNDED' | 'PARTIALLY_REFUNDED'; membershipId?: string; limit?: number; offset?: number } = {}) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/payments/history`, {
      headers: { Authorization: `Bearer ${token}` },
      params,
    });
    return res.data as { payments: any[]; pagination: any };
  },

  async refund(paymentIntentId: string, amount?: number, reason?: 'duplicate' | 'fraudulent' | 'requested_by_customer') {
    const token = localStorage.getItem('accessToken');
    const res = await axios.post(`${API_BASE_URL}/api/payments/refund`, { paymentIntentId, amount, reason }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { message: string; refundAmount: number; status: string };
  },

  async getPaymentMethods() {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/payments/methods`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { paymentMethods: any[] };
  },

  async createBillingPortalSession(): Promise<{ url: string }> {
    const token = localStorage.getItem('accessToken');
    const res = await axios.post(`${API_BASE_URL}/api/payments/billing-portal`, {}, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  async createCheckoutSession(tierId: string): Promise<{ sessionId: string; url: string }> {
    const token = localStorage.getItem('accessToken');
    const res = await axios.post(`${API_BASE_URL}/api/payments/checkout/create`, { tierId }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },
};

